<template>
    <div class="cv-item-root p-2" :class="[enumKey]">
        <div class="d-flex align-items-center justify-content-left">
            <BaseIcon name="file" size="3x" class="SUCCESS" />
            <div v-if="cv.default" class="padding4px">
                <BaseIcon class="m-auto SUCCESS" name="star" color="secondary" size="2x" />
            </div>

            <IconBtn v-else class="m-auto notdefault" name="star" size="2x" @click="onFavourite" />
        </div>

        <div>
            <h6 class="title bold mb-1">{{ cv.fileName }}</h6>
        </div>
        <div class="d-flex flex-row">
            <IconBtn
                v-if="cv.downloadUrl"
                class="m-auto SUCCESS"
                name="download"
                color="secondary"
                @click="onDownload(cv.downloadUrl)"
            />
            <!-- <IconBtn class="m-auto" name="pen" color="secondary" @click="onEdit" /> -->
            <IconBtn class="m-auto SUCCESS" name="trash" color="secondary" @click="onDelete" />
        </div>
    </div>
</template>

<script>
import moment from 'moment';

// Utils
import StateEnum from '~/utils/StateEnum';
import DialogService from '~/services/DialogService';

export default {
    name: 'CVItem',
    props: {
        cv: { type: Object, default: () => {} },
    },
    computed: {
        enumKey() {
            return Object.keys(StateEnum)[this.state] || '';
        },
    },
    methods: {
        graduationText() {
            const graduationDate = moment(this.$props.graduationDate);
            if (!graduationDate.isValid() || moment().diff(graduationDate) < 0) {
                return this.$t('spotlight.education.notGraduated');
            }
            return this.$t('spotlight.education.graduatedIn', {
                date: graduationDate.format('MMM YYYY'),
            });
        },
        onEdit() {
            DialogService.openEditCVDialog(this.cv);
        },
        getSchool() {
            return this.school || {};
        },
        onDelete() {
            this.$emit('delete', this.cv);
        },
        onFavourite() {
            this.$emit('default', this.cv);
        },
        onDownload(url) {
            window.location.assign(url);
        },
    },
};
</script>

<style scoped>
.notdefault {
    color: rgb(206, 206, 206);
}
.padding4px {
    padding: 4px;
}
.cv-item-root {
    border: 1px solid var(--success);
    border-radius: 2px;

    display: grid;
    grid-template-columns: 80px auto 120px;
    grid-gap: 16px;
}

@media only screen and (max-width: 600px) {
    .cv-item-root {
        grid-template-columns: auto;
        justify-content: center;
        text-align: center;
    }
}
</style>
